/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, jsx } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { EditRow } from './EditRow';
import type { MemoryEditItem } from './types';

const styles = cssMap({
	container: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		border: `${token('border.width')} solid ${token('color.border')}`,
		borderRadius: token('radius.xlarge'),
		overflow: 'hidden',
	},
	list: {
		overflowY: 'auto',
		overflowX: 'hidden',
		scrollbarWidth: 'thin',
		scrollbarGutter: 'stable',
	},
});

type EditsListProps = {
	edits: MemoryEditItem[];
	editIdConfirming: string | null;
	editIdDeleting: string | null;
	onDeleteClick: (editId: string) => void;
	onCancelConfirm: () => void;
	onConfirmRemove: (editId: string) => void;
};

export const EditsList = ({
	edits,
	editIdConfirming,
	editIdDeleting,
	onDeleteClick,
	onCancelConfirm,
	onConfirmRemove,
}: EditsListProps): JSX.Element => (
	<Stack xcss={styles.container} space="space.0">
		<Box xcss={styles.list}>
			{edits.map((edit, index) => (
				<EditRow
					key={edit.id}
					edit={edit}
					isFirst={index === 0}
					confirmingId={editIdConfirming}
					isDeletingId={editIdDeleting}
					onDeleteClick={() => onDeleteClick(edit.id)}
					onCancelConfirm={onCancelConfirm}
					onConfirmRemove={() => onConfirmRemove(edit.id)}
				/>
			))}
		</Box>
	</Stack>
);
